import React, { Suspense } from 'react';
import { BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom';
import './assets/css/main.css';
import './assets/css/bootstrap.min.css';
import Routers from './routers';

import './i18n';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <Suspense fallback={(<div>Loading</div>)}>
        <BrowserRouter>
            <Routers />
        </BrowserRouter>
    </Suspense>
    , document.getElementById('root'));
serviceWorker.unregister();
